import { HttpErrorResponse } from '@angular/common/http';
import { StatusPreautorisation } from '../../../shared/modeles/variables';
import { TypeProjet } from '../../../shared/constants/type-projet.enum';
import { CoordonneesModele } from '../../../shared/modeles/coordonnees.modele';
import { StepEnum } from '../constants/step.enum';
import { DepensesResidenceCouranteModel } from '../models/depenses-residence-courante.model';
import { PreautorisationModel } from '../models/preautorisation.model';
import { ValiderCodeInvitationCourrielModel } from '../models/valider-code-invitation-courriel.model';
import { TypeMultiproprietaireEnum } from '../constants/type-multiproprietaire.enum';
import { ErreurPreautCoemprunteur } from '../models/erreur-validation.modele';
import { TypeProprieteEnum } from '../constants/type-propriete.enum';
import { FrequenceEnum } from '../../../shared/constants/frequence.config';
import { TypeMultiplexEnum } from '../constants/type-multiplex.enum';
import { InstitutionEnum } from '../constants/institution.enum';

export class NavigatePageFormulaire {
  static type = '[Preautorisation experimente] NavigatePageFormulaire';
}

export class NavigatePageAccueil {
  static type = '[Preautorisation experimente] NavigatePageAccueil';
}

export class NavigatePageResultat {
  static type = '[Preautorisation experimente] NavigatePageResultat';
}

export class NavigatePageInvitation {
  static type = '[Preautorisation experimente] NavigatePageInvitation';
}

export class NavigatePageNonEligible {
  static type = '[Preautorisation experimente] NavigatePageNonEligible';
}

export class NavigatePageDetails {
  static type = '[Preautorisation experimente] NavigatePageDetails';
}
export class NavigatePagePreautEnCours {
  static type = '[Preautorisation experimente] NavigatePagePreautEnCours';
  constructor(
    public typeProjet: TypeProjet,
    public statut: StatusPreautorisation,
    public institution: InstitutionEnum
  ) {}
}

export class NavigatePreautActive {
  static type = '[Preautorisation experimente] NavigatePreautActive';
  constructor(public typeProjet: TypeProjet, public statut: StatusPreautorisation) {}
}

export class NavigateDashboard {
  static type = '[Preautorisation experimente] NavigateDashboard';
}

export class NavigatePagePannePreadmissibilite {
  static type = '[Preautorisation experimente] NavigatePagePannePreadmissibilite';
}

export class NavigatePageAnnuleParCoemprunteur {
  static type = '[Preautorisation experimente] NavigatePageAnnuleParCoemprunteur';
}

export class GoNextStep {
  static type = '[Preautorisation experimente] GoNextStep';
}

export class GoPreviousStep {
  static type = '[Preautorisation experimente] GoPreviousStep';
}

export class GoToStep {
  static type = '[Preautorisation experimente] GoToStep';
  constructor(public step: StepEnum) {}
}

export class Prefill {
  static type = '[Preautorisation experimente] Prefill';
}

export class PrefillSuccess {
  static type = '[Preautorisation experimente] PrefillSuccess';
  constructor(public preautorisation: Partial<PreautorisationModel>) {}
}

export class PrefillFailed {
  static type = '[Preautorisation experimente] PrefillFailed';
  constructor(public response: HttpErrorResponse) {}
}

export class SaveAiguilleurResidencePrincipale {
  static type = '[Preautorisation experimente] SaveAiguilleurResidencePrincipale';
  constructor(public isResidencePrincipale: 'O' | 'N') {}
}

export class SaveAiguilleurSalarie {
  static type = '[Preautorisation experimente] SaveAiguilleurSalarie';
  constructor(public isSalarie: 'O' | 'N') {}
}

export class SaveAiguilleurCitoyennete {
  static type = '[Preautorisation experimente] SaveAiguilleurCitoyennete';
  constructor(public isCitoyenCanadien: 'O' | 'N') {}
}

export class SaveAiguilleurMultiproprietaire {
  static type = '[Preautorisation experimente] SaveAiguilleurMultiproprietaire';
  constructor(public typeMultiproprietaire: TypeMultiproprietaireEnum) {}
}

export class SaveEtapeTypePropriete {
  static type = '[Preautorisation experimente] SaveEtapeTypePropriete';
  constructor(
    public typePropriete: TypeProprieteEnum,
    public typeMultiplex: TypeMultiplexEnum,
    public nbrLogements: number,
    public indHabitableHiver: boolean | null
  ) {}
}

export class SaveEtapeAchatADeux {
  static type = '[Preautorisation experimente] SaveEtapeAchatADeux';
  public payload: Partial<PreautorisationModel>;
  constructor(public indCoemprunteurProprieteActuelle: boolean) {
    this.payload = { indCoemprunteurProprieteActuelle };
  }
}

export class SaveEtapeAchatMemeCoemprunteur {
  static type = '[Preautorisation experimente] SaveEtapeAchatMemeCoemprunteur';
  public payload: Partial<PreautorisationModel>;
  constructor(public indMemeCoemprunteurProprieteActuelle: boolean) {
    this.payload = { indMemeCoemprunteurProprieteActuelle };
  }
}

export class EditStep {
  static type = '[Preautorisation experimente] EditStep';
  constructor(public step: StepEnum) {}
}

export class CompleteEditStep {
  static type = '[Preautorisation experimente] CompleteEditStep';
}

export class GoToNextInvalidStepOrCompleteEdit {
  static type = '[Preautorisation experimente] GoToNextInvalidStepOrCompleteEdit';
}

export class CancelEditStep {
  static type = '[Preautorisation experimente] CancelEditStep';
}

export class SaveEtapeRevenuBrut {
  static type = '[Preautorisation experimente] SaveEtapeRevenuBrut';
  public payload: Partial<PreautorisationModel>;
  constructor(revenuAnnuelBrut: number) {
    this.payload = { emploi: { revenuAnnuelBrut } };
  }
}

export class SaveEtapeRevenuLocatif {
  static type = '[Preautorisation experimente] SaveEtapeRevenuLocatif';
  public payload: Partial<PreautorisationModel>;
  constructor(revenuLocatifEstime: number, codeFrequenceRevenuLocatifEstime: FrequenceEnum) {
    this.payload = { revenuLocatifEstime, codeFrequenceRevenuLocatifEstime };
  }
}

export class SaveEtapeCoemprunteur {
  static type = '[Preautorisation experimente] SaveEtapeCoemprunteur';
  public payload: Partial<PreautorisationModel>;
  constructor(indCoemprunteur: boolean, courrielCoemprunteur?: string) {
    this.payload = { indCoemprunteur, courrielCoemprunteur };
  }
}

export class SaveEtapeCoordonnees {
  static type = '[Preautorisation experimente] SaveEtapeCoordonnees';
  public payload: Partial<PreautorisationModel>;
  constructor(coordonnees: CoordonneesModele) {
    this.payload = { coordonnees };
  }
}

export class SaveEtapeHypotheque {
  static type = '[Preautorisation experimente] SaveEtapeHypotheque';
  public payload: Partial<PreautorisationModel>;
  constructor(depensesResidenceCourante: DepensesResidenceCouranteModel) {
    this.payload = { depensesResidenceCourante };
  }
}

export class SaveEtapePrixPropriete {
  static type = '[Preautorisation experimente] SaveEtapePrixPropriete';
  public payload: Partial<PreautorisationModel>;
  constructor(montantPropriete: number) {
    this.payload = { montantPropriete };
  }
}

export class SaveEtapeMiseDeFonds {
  static type = '[Preautorisation experimente] SaveEtapeMiseDeFonds';
  public payload: Partial<PreautorisationModel>;
  constructor(miseDeFonds: number) {
    this.payload = { miseDeFonds };
  }
}

export class ValiderPreadmissibilite {
  static type = '[Preautorisation experimente] ValiderPreadmissibilite';
}

export class Submit {
  static type = '[Preautorisation experimente] Submit';
}

export class SubmitSuccess {
  static type = '[Preautorisation experimente] SubmitSuccess';
  constructor(public preautorisation: PreautorisationModel) {}
}

export class SubmitFailed {
  static type = '[Preautorisation experimente] SubmitFailed';
  constructor(public codeErreur?: ErreurPreautCoemprunteur) {}
}

export class Load {
  static type = '[Preautorisation experimente] Load';
}

export class SaveEtapeConsentement {
  static type = '[Preautorisation experimente] SaveEtapeConsentement';
  constructor(public idConsentement: string) {}
}

export class CancelPreautorisation {
  static type = '[Preautorisation experimente] CancelPreautorisation';
}

export class CancelWithConfirmation {
  static type = '[Preautorisation experimente] CancelWithConfirmation';
}

export class ResetState {
  static type = '[Preautorisation experimente] ResetState';
}

export class AccepterContreOffre {
  static type = '[Preautorisation experimente] AccepterContreOffre';
}

export class AccepterContreOffreFailed {
  static type = '[Preautorisation experimente] AccepterContreOffreFailed';
}

export class AccepterContreOffreSuccess {
  static type = '[Preautorisation experimente] AccepterContreOffreSuccess';
  constructor(public preautorisation: PreautorisationModel) {}
}

export class RefuserContreOffre {
  static type = '[Preautorisation experimente] RefuserContreOffre';
}

export class RefuserContreOffreFailed {
  static type = '[Preautorisation experimente] RefuserContreOffreFailed';
}

export class RefuserContreOffreSuccess {
  static type = '[Preautorisation experimente] RefuserContreOffreSuccess';
  constructor(public preautorisation: PreautorisationModel) {}
}

export class SelectionnerTaux {
  static type = '[Preautorisation experimente] SelectionnerTaux';
  constructor(public idOffreTarificationBancaire: string) {}
}

export class SelectionnerTauxFailed {
  static type = '[Preautorisation experimente] SelectionnerTauxFailed';
}

export class SelectionnerTauxSuccess {
  static type = '[Preautorisation experimente] SelectionnerTauxSuccess';
  constructor(public preautorisation: PreautorisationModel) {}
}

export class ValiderCodeInvitationCourriel {
  static type = '[Preautorisation experimente] ValiderCodeInvitation';
  constructor(public codeInvitationCourriel: ValiderCodeInvitationCourrielModel) {}
}

export class ValiderCodeInvitationCourrielFailed {
  static type = '[Preautorisation experimente] ValiderCodeInvitationCourrielFailed';
  constructor(public response: HttpErrorResponse) {}
}

export class ValiderCodeInvitationCourrielSuccess {
  static type = '[Preautorisation experimente] ValiderCodeInvitationCourrielSuccess';
  constructor(public preautorisation: Partial<PreautorisationModel>) {}
}

export class RefuserProjetSuccess {
  static type = '[Preautorisation experimente] RefuserProjetSuccess';
}

export class RefuserProjet {
  static type = '[Preautorisation experimente] RefuserProjet';
}

export class RefuserProjetFailed {
  static type = '[Preautorisation experimente] RefuserProjetFailed';
}

export class PatchDebug {
  static type = '[Preautorisation experimente] PatchDebug';
  constructor(public preautorisation: any) {}
}
